///
/// EarthBrowser
///
/// Volcano Browser Feature
///
/// Manages volcano browser window lifecycle and command palette registration
///
/// Created by Matt Giger on December 14, 2025
/// Copyright (c) 2025 Geodata Labs
///

import { useEffect } from 'react'
import { Mountain } from 'lucide-react'
import { VolcanoBrowserRenderer } from '@/components/features/volcano-browser/VolcanoBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const VOLCANO_WINDOW_ID = 'volcano-browser'
const VOLCANO_WINDOW_WIDTH = 700
const VOLCANO_WINDOW_HEIGHT = 500

export function VolcanoBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const volcanoWindow = datasetWindows[VOLCANO_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'volcano-browser',
			command: {
				id: 'volcanoes',
				title: 'Volcanoes',
				icon: <Mountain className="w-4 h-4 text-orange-500" />,
				category: 'Datasets',
				enabled: true,
			onSelect: () => {
				openOrRestoreWindow(
					dispatch,
					datasetWindows,
					VOLCANO_WINDOW_ID,
					{
						id: VOLCANO_WINDOW_ID,
						title: 'Volcanoes',
						windowType: 'volcano',
						x: 120,
						y: 120,
						width: VOLCANO_WINDOW_WIDTH,
						height: VOLCANO_WINDOW_HEIGHT,
						isMaximized: false,
						isVisible: true,
					}
				)
			}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!volcanoWindow) {
		return null
	}

	return (
		<VolcanoBrowserRenderer
			windowId={VOLCANO_WINDOW_ID}
			windowState={volcanoWindow}
		/>
	)
}

